<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <div class="content-section">
    <h2>Assurance Chiens - Chats - Animaux</h2>
    <p>
      Comme vous, les animaux domestiques peuvent tomber malades, voir un médecin vétérinaire, subir une opération lourde, et dans ce cas il est judicieux de 
      souscrire une assurance Assurance Chiens – Chats – Animaux similaires à l'<a href="#">Assurance Mutuelle Santé Individuelle</a>.
    </p>
    <p>
      Si vous êtes à la recherche de ce type d'<strong>assurance Chiens-Chats</strong>, merci de prendre contact avec nous car il existe trop de déclinaisons 
      selon votre situation personnelle.
    </p>
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-après : 
      <strong>APRIL, SOLLY AZAR, ALPTIS, NEOLIANE, ZEPHIR...</strong>
    </p>
  </div>
</app-page-layout>
